// src/pages/MentionsLegalesPage.jsx
import React from 'react';
import LegalLayout from '../components/LegalLayout';
import Seo from '../components/Seo';

const MentionsLegalesPage = () => {
  const sections = [
    {
      title: 'Éditeur du site',
      content: `
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p><strong>Raison sociale</strong> : Y A Quoi A Manger by J7LAB</p>
            <p><strong>Forme juridique</strong> : J7 LAB SAS</p>
            <p><strong>Capital social</strong> : 4000 euros</p>
            <p><strong>Siège social</strong> : 10 Chemin du lac 43000 POLIGNAC FRANCE</p>
            <p><strong>SIRET</strong> : 94361668000014</p>
          </div>
          <div>
            <p><strong>N° TVA intracommunautaire</strong> : FR15943616680</p>
            <p><strong>Email</strong> : info@j7lab.com</p>
            <p><strong>Directeur de la publication</strong> : J7 GROUP</p>
          </div>
        </div>
      `
    },
    {
      title: 'Hébergeur',
      content: `
        <p><strong>Raison sociale</strong> : AMAZON WEB SERVICES</p>
        <p><strong>Siège social</strong> : 410 Terry Ave N, Seattle, WA 98109, États-Unis</p>
        <p><strong>Téléphone</strong> : +1 206-266-1000</p>
      `
    },
    {
      title: 'Propriété intellectuelle',
      content: `
        <p>Le site Y A QUOI A MANGER (alias YAQAM), son contenu et tous les éléments qui le composent sont protégés par le droit d'auteur, le droit des marques et autres droits de propriété intellectuelle.</p>
        <p class="mt-2">La marque Y A QUOI A MANGER (alias YAQAM), les logos, graphismes et autres signes distinctifs qui apparaissent sur le site sont la propriété de Y A QUOI A MANGER (alias YAQAM) ou font l'objet d'une autorisation d'utilisation.</p>
        <p class="mt-2">Toute reproduction ou représentation, totale ou partielle, du site ou de l'un des éléments qui le composent, sans l'autorisation expresse de Y A QUOI A MANGER (alias YAQAM), est interdite et constituerait une contrefaçon sanctionnée par le Code de la propriété intellectuelle.</p>
      `
    },
    {
      title: 'Liens hypertextes',
      content: `
        <p>Le site Y A QUOI A MANGER (alias YAQAM) peut contenir des liens hypertextes vers d'autres sites internet. Y A QUOI A MANGER (alias YAQAM) n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.</p>
      `
    },
    {
      title: 'Crédits',
      content: `
        <p><strong>Conception et développement</strong> : [nom]</p>
        <p><strong>Design</strong> : [nom]</p>
        <p><strong>Photos</strong> : [sources]</p>
      `
    },
    {
      title: 'Règlement des litiges',
      content: `
        <p>En cas de litige, une solution amiable sera recherchée avant tout recours judiciaire. À défaut, les tribunaux du ressort de la Cour d'appel de [ville] seront compétents.</p>
      `
    }
  ];

  return (
    <>
      <Seo
        title="Mentions légales"
        description="Informations légales et coordonnées de l'éditeur du site YAQAM."
        breadcrumb
        noindex
      />
      <LegalLayout title="Mentions Légales">
      <div className="space-y-8">
        {sections.map((section, index) => (
          <div key={index} className="border-b border-gray-100 pb-6 last:border-0 last:pb-0">
            <h2 className="text-xl font-semibold mb-4 text-[#2C3E50] border-l-4 border-[#87A96B] pl-4">
              {section.title}
            </h2>
            <div 
              className="text-[#2C3E50] leading-relaxed"
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          </div>
        ))}
      </div>
      
      <style jsx>{`
        :global(.space-y-8 strong) {
          color: #87A96B;
          font-weight: 600;
        }
        :global(.space-y-8 p) {
          margin-bottom: 0.5rem;
        }
        :global(.grid p) {
          color: #2C3E50;
        }
      `}</style>
    </LegalLayout>
    </>
  );
};

export default MentionsLegalesPage;
